import { enableProdMode, provideZoneChangeDetection, ErrorHandler } from '@angular/core';

import { provideHttpClient } from '@angular/common/http';
import { GlobalErrorHandler } from 'src/common/services/globalErrorHandler';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { bootstrapApplication } from '@angular/platform-browser';
import {
  withInMemoryScrolling,
  withRouterConfig,
  provideRouter,
  withComponentInputBinding,
  withPreloading,
  TitleStrategy,
} from '@angular/router';
import { AppRoutes } from './app.routing';
import { RootComponent } from './root.component';
import { CombinedTitleStrategy } from './combinedTitleStrategy';
import { NetworkAwarePreloadStrategy } from './networkAwarePreloadStrategy';

if (process.env['NODE_ENV'] === 'production') {
  enableProdMode();
}

bootstrapApplication(RootComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideHttpClient(),
    provideNativeDateAdapter(),
    provideAnimationsAsync(),
    { provide: ErrorHandler, useExisting: GlobalErrorHandler },
    {
      provide: OVERLAY_DEFAULT_CONFIG,
      useValue: { usePopover: false },
    },
    provideRouter(
      AppRoutes,
      withInMemoryScrolling({ scrollPositionRestoration: 'disabled' }),
      withRouterConfig({ urlUpdateStrategy: 'eager', onSameUrlNavigation: 'reload' }),
      withComponentInputBinding(),
      withPreloading(NetworkAwarePreloadStrategy),
    ),
    { provide: TitleStrategy, useClass: CombinedTitleStrategy },
  ],
}).catch((err) => {
  console.error(err);
});
